import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

// Design guide: Fluent tokens only (light / dark / high contrast), label above the field,
// messages as MessageBar banners, state never conveyed by color alone (icon + text).
export const useStorageDialogsStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalM,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
  },
  text: {
    ...shorthands.margin(0),
    color: tokens.colorNeutralForeground1,
    overflowWrap: 'anywhere',
  },
  secondaryText: {
    ...shorthands.margin(0),
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground2,
    overflowWrap: 'anywhere',
  },
  strong: {
    fontWeight: tokens.fontWeightSemibold,
  },
  errorList: {
    ...shorthands.margin(tokens.spacingVerticalXS, 0, 0),
    paddingLeft: tokens.spacingHorizontalL,
    overflowWrap: 'anywhere',
  },
});
